import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import AwardCreate from '../create/AwardCreate';
import PropOverviewCreate from '../create/PropOverviewCreate';
import ReviewCreate from '../create/ReviewCreate';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
       
        <Modal.Content>
        {this.props.award && <AwardCreate/>}
        {this.props.propOverview && <PropOverviewCreate/>}
        {this.props.review && <ReviewCreate btn={this.props.btn}/>}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
